import type { WireAppTheme } from "@glideapps/theme";

export function isDarkAppTheme(theme: WireAppTheme): boolean {
    return /DarkWireApp/i.test(theme.overlayName);
}
